import(/* webpackMode: "eager" */ "/vercel/path0/src/app/for-students/login/page.tsx");
